































import Vue from 'vue';
import {
  mapState
} from 'vuex';
import store from '../store/index';
import { CheckboxGroup, Checkbox } from 'element-ui';
Vue.component('el-checkbox-group', CheckboxGroup);
Vue.component('el-checkbox', Checkbox);

export default Vue.extend({
  name: 'Signature',
  computed: mapState({
    reportType: (state: any) => store.getters.getReportType,
    checkInfo: (state: any) => store.getters.getCheckInfo,
    checkText: (state: any) => store.getters.getCheckText
  }),
  data() {
    return {
      yes: false,
      no: false
    };
  },
  methods: {
  
  },
  mounted() {
    if(this.checkInfo && this.checkInfo.reportModel && this.checkInfo.reportModel.paperFromWfSearch) {
      this.yes = true;
    } else {
      this.no = true;
    }
  }
});
